module.exports = __webpack_public_path__ + "862d3d5c5c9e34cde7279f778ffb6d62.svg";